import { HeadphonesIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const OnEarHeadphone = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <HeadphonesIcon size={Sizes[size]} {...rest} />;
};

OnEarHeadphone.displayName = 'OnEarHeadphone';
